import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { TextField, Box, Button, Tooltip, FormControl } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import 'react-phone-number-input/style.css';
import { addOrUpdateEmployeeOffboardingRequest } from '../../services/EmployeeService';
import './EmployeeOffboarding.css';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import KeycloakService from '../../services/KeycloakService';
import dayjs from 'dayjs';
import moment from 'moment';
import {
  checkForEmailId,
  getAllEmployees,
  updateEmployeeOffBoardingRequest,
} from '../../services/EmployeeService';
import { CANCEL_BUTTON_TEXT } from '../../constants';
import { useDispatch } from 'react-redux';
import { SHOW_NOTIFICATION } from '../../constants';

// Must mirror the backend's ApplicationStatus enum (commons/dto/enums/ApplicationStatus.java).
const APPLICATION_STATUS_VALUES = [
  'APPROVED',
  'PENDING',
  'REJECTED',
  'TASK_PENDING',
  'TASK_APPROVED',
  'NEEDS_DISCUSSION',
  'CANCELLED',
  'NOTICE_PERIOD',
];

const EditCard = (props) => {
  const {
    isOffboard,
    employee,
    isAddButton,
    handleClose,
    isHr,
    isAdmin,
    updatedEmployeeDetails,
    updatedFiles,
    updatedShowErrorMessageEld,
    updatedShowErrorMessageDol,
    updatedShowErrorMessageOEmail,
    updatedShowErrorMessage,
    allEmployeesDetails,
    handleToggle,
    selectedStatus,
  } = props;
  const [employeeDetails, setEmployeeDetails] = useState(
    employee ? employee : updatedEmployeeDetails,
  );
  const dispatch = useDispatch();
  const [showErrorMessage, setShowErrorMessage] = useState(
    updatedShowErrorMessage,
  );
  const [showErrorMessageEld, setShowErrorMessageEld] = useState(
    updatedShowErrorMessageEld,
  );
  const [showErrorMessageDol, setShowErrorMessageDol] = useState(
    updatedShowErrorMessageDol,
  );
  const [showErrorMessageOEmail, setShowErrorMessageOEmail] = useState(
    updatedShowErrorMessageOEmail,
  );
  const [showErrorMessageOEmail1, setShowErrorMessageOEmail1] = useState(
    updatedShowErrorMessageOEmail,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = React.useState(updatedFiles);

  const [isValidOEmail, setIsValidOEmail] = useState(true);
  const [isDateValid, setIsDateValid] = useState(true);
  const [eldError, setEldError] = React.useState(null);

  const Approve = 'Approve';
  const Save = 'Save';
  useEffect(() => {
    if (isAddButton) {
      setEmployeeDetails(updatedEmployeeDetails);
      setFiles(updatedFiles);
    }
  }, []);

  useEffect(() => {}, [employeeDetails]);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const handleKeyDown = (e) => {
    if (e.target.value.length >= 17) {
      e.preventDefault(); // Prevent typing more characters
    }
  };

  const saveData = async () => {
    setIsLoading(true);
    let employee = '';

    let rest = {
      approverId: '',
      endDate:
        employeeDetails.endDate instanceof Date
          ? employeeDetails.endDate.toISOString().slice(0, 10)
          : employeeDetails.endDate
            ? employeeDetails.endDate.slice(0, 10)
            : new Date().toISOString().slice(0, 10),
      expectedEndDate:
        employeeDetails.expectedEndDate instanceof Date
          ? employeeDetails.expectedEndDate.toISOString().slice(0, 10)
          : employeeDetails.expectedEndDate
            ? employeeDetails.expectedEndDate.slice(0, 10)
            : new Date().toISOString().slice(0, 10),
      comments: employeeDetails?.comments || '',
      // employeeDetails.status may be the *employee's own* status (e.g.
      // "ACTIVE") rather than an offboarding application status, so only use
      // it when it's actually a valid ApplicationStatus value.
      status: APPLICATION_STATUS_VALUES.includes(employeeDetails?.status)
        ? employeeDetails.status
        : 'PENDING',
    };
    if (
      isAdmin &&
      (selectedStatus.value === 'PENDING' ||
        selectedStatus.value === 'REJECTED')
    )
      rest.status = 'APPROVED';

    if (
      files != null &&
      rest?.endDate &&
      rest?.expectedEndDate &&
      !showErrorMessageOEmail
    ) {
      setShowErrorMessage(false);
      setShowErrorMessageEld(false);
      setShowErrorMessageDol(false);
      setShowErrorMessageOEmail(false);

      employee = await addOrUpdateEmployeeOffboardingRequest(
        employeeDetails,
        rest,
      );

      if (employee.status !== 200) {
        dipatchNotification(employee.type, employee.message);
        setIsLoading(false);
        return;
      }

      setEmployeeDetails({
        applierId: KeycloakService.getUserDetail(),
        tenantId: ' process.env.REACT_APP_TENANT_ID',
        employeeId: '',
        expectedEndDate: '',
        status: 'PENDING',
        endDate: '',
        organizationEmailId: '',
      });
      setFiles(null);
      if (employee.isError == false) {
        setIsLoading(false);
        handleClose();
        handleToggle('PENDING');
        setShowErrorMessageEld(false);
        setShowErrorMessageDol(false);
      }
    } else if (showErrorMessageOEmail) {
      setShowErrorMessageOEmail(true);
    } else if (!employeeDetails?.endDate) {
      setShowErrorMessageEld(true);
    } else if (!employeeDetails?.expectedEndDate) {
      setShowErrorMessageDol(true);
    } else if (files == null) {
      setShowErrorMessage(true);
    }

    setIsLoading(false);
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 600);
    };
  };
  


  const onEndDatePicketInputChange = (e) => {
    const { endDate, ...newemployeeDetails } = employeeDetails;
    const formattedDate = dayjs(e).format('YYYY-MM-DD');
    if (formattedDate === 'Invalid Date') setIsDateValid(false);
    else setIsDateValid(true);
    setEmployeeDetails({
      ...newemployeeDetails,
      endDate: formattedDate,
    });
  };

  const onExpectedEndDatePicketInputChange = (e) => {
    const { expectedEndDate, ...newemployeeDetails } = employeeDetails;
    const formattedDate = dayjs(e).format('YYYY-MM-DD');
    if (formattedDate === 'Invalid Date') setIsDateValid(false);
    else setIsDateValid(true);
    setEmployeeDetails({
      ...newemployeeDetails,
      expectedEndDate: formattedDate,
    });
  };

  const onChange = async (event, value, id) => {
    const regex = /^(|^[A-Za-z\s]+)$/; // Regular expression to allow only alphabetic characters and spaces
    if (id === 'firstName') {
      if (!regex.test(value)) {
        // Value contains numbers, do not update state
        return;
      }
    } else if (id === 'tenantId') {
      const { tenantId, ...newemployeeDetails } = employeeDetails;
      setEmployeeDetails({
        ...newemployeeDetails,
        tenantId: value,
      });
    } else if (id === 'organizationEmailId') {
      setIsValidOEmail(false);
      const { organizationEmailId, ...newemployeeDetails } = employeeDetails;
      setEmployeeDetails({
        ...newemployeeDetails,
        organizationEmailId: value,
      });
    }
  };
  // console.log(designationNames, 'home');
  const handleBlur = async (id, value) => {
    const regex = /^$|^[A-Za-z0-9._%+-]+@beehyv\.com$/i;

    const PEmailregex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    try {
      if (id === 'organizationEmailId') {
        if (!regex.test(value)) {
          setShowErrorMessageOEmail1(true);
          setShowErrorMessageOEmail(true);
          setIsValidOEmail(false);
          return;
        } else {
          setShowErrorMessageOEmail1(false);
          setShowErrorMessageOEmail(false);
        }
        if (employee && value === employee.organizationEmailId) {
          setShowErrorMessageOEmail(false);
          setIsValidOEmail(true);
          return;
        }
        const checkingEmailId = await checkForEmailId(value);
        if (checkingEmailId?.data?.data === true) {
          setShowErrorMessageOEmail(false);
          setIsValidOEmail(true);
        } else {
          setShowErrorMessageOEmail(true);
          setIsValidOEmail(false);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const validationFn = useCallback(debounce(handleBlur), []);

  const editData = async () => {
    try {
      if (isAdmin) {
        employeeDetails.status = 'APPROVED';
      }
      if (isHr && employeeDetails.status == 'REJECTED') {
        employeeDetails.status = 'PENDING';
      }
      let file1 = files;
      if (file1 == 1) {
        file1 = null;
      }
      let editEmployeeList = null;
      isHr
        ? (editEmployeeList = await addOrUpdateEmployeeOffboardingRequest(
            employeeDetails,
            file1,
          ))
        : (editEmployeeList = await updateEmployeeOffBoardingRequest(
            {
              ...employeeDetails,
              approverId: KeycloakService.getUserDetail(),
            },
            file1,
          ));
      if (editEmployeeList.status !== 200) {
        dipatchNotification(editEmployeeList.type, editEmployeeList.message);
        setIsLoading(false);
        handleToggle(selectedStatus.value);
        return;
      }

      handleToggle(selectedStatus.value);
      handleClose();
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  const card = (
    <>
      <FormControl>
        <form
          sx={{ padding: '1rem' }}
          onSubmit={(event) => {
            event.preventDefault();
            saveData();
          }}
        >
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'auto',
                justifyContent: 'space-between',
              }}
            >
              <div>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    flexDirection: 'row',
                    margin: '1rem',
                  }}
                ></div>
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexWrap: 'wrap',
                    flexDirection: 'row',
                    margin: '1rem',
                  }}
                >
                  <div
                    style={{
                      width: '28.7%',
                      marginRight: '0.4%',
                      marginLeft: '0.4%',
                      marginTop: '0.5rem',
                      marginBottom: '1.5rem',
                      marginLeft: '3.8%',
                      justifyContent: 'space-between',
                    }}
                  >
                    <FormControl sx={{ width: '100%' }}>
                      <TextField
                        required
                        id="organizationEmailId"
                        type={'email'}
                        label="Organization Email Id"
                        value={
                          employeeDetails?.organizationEmailId
                            ? employeeDetails?.organizationEmailId
                            : employeeDetails?.emailId || ''
                        }
                        // onChange={(e) => {
                        //   onChange(e, e.target.value, e.target.id);
                        //   validationFn(e.target.id, e.target.value);
                        // }}
                        disabled
                        className="onFocusBorder"
                        error={showErrorMessageOEmail}
                      />
                    </FormControl>
                  </div>
                  <div
                    style={{
                      width: '28.7%',
                      marginRight: '0.4%',
                      marginLeft: '0.4%',
                      marginTop: '0.5rem',
                      marginBottom: '1.5rem',
                      marginLeft: '3.8%',
                      justifyContent: 'space-between',
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Tooltip
                        open={showErrorMessageEld && !employeeDetails?.endDate}
                        classes={{
                          tooltip: 'custom-tooltip1',
                          arrow: 'custom-tooltip-arrow1',
                        }}
                        placement="top"
                      >
                        <FormControl required>
                          <DatePicker
                            label="Expected Leaving Date*"
                            id="eld"
                            value={employeeDetails?.expectedEndDate}
                            onChange={onExpectedEndDatePicketInputChange}
                            minDate={
                              employeeDetails?.dateOfJoining
                                ? dayjs(employeeDetails.dateOfJoining)
                                : null
                            }
                            renderInput={(params) => (
                              <TextField tool {...params} error={false} />
                            )}
                          />
                        </FormControl>
                      </Tooltip>
                    </LocalizationProvider>
                  </div>
                  <div
                    style={{
                      width: '28.7%',
                      marginRight: '0.4%',
                      marginLeft: '0.4%',
                      marginTop: '0.5rem',
                      marginBottom: '1.5rem',
                      marginLeft: '3.8%',
                      justifyContent: 'space-between',
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Tooltip
                        open={
                          showErrorMessageDol &&
                          !employeeDetails?.expectedendDate
                        }
                        classes={{
                          tooltip: 'custom-tooltip1',
                          arrow: 'custom-tooltip-arrow1',
                        }}
                        placement="top"
                      >
                        <FormControl required>
                          <DatePicker
                            label="Date of Leaving*"
                            id="dol"
                            value={employeeDetails?.endDate}
                            onChange={onEndDatePicketInputChange}
                            minDate={
                              employeeDetails?.dateOfJoining
                                ? dayjs(employeeDetails.dateOfJoining)
                                : null
                            }
                            renderInput={(params) => (
                              <TextField {...params} error={false} />
                            )}
                          />
                        </FormControl>
                      </Tooltip>
                    </LocalizationProvider>
                  </div>
                </div>
              </div>
              <div className="space-between-container">
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    marginRight: '12px',
                    marginLeft: '30px',
                    marginBottom: '20px',
                    paddingBottom: '20px',
                    justifyContent: 'space-between',
                  }}
                >
                  <LoadingButton
                    variant="contained"
                    type="submit"
                    disabled={!isValidOEmail || !isDateValid}
                    loading={isLoading}
                    style={{
                      marginRight: '27px',
                    }}
                  >
                    {isAdmin ? Approve : Save}
                  </LoadingButton>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleClose}
                  >
                    {CANCEL_BUTTON_TEXT}
                  </Button>
                </div>
              </div>
            </div>
          </Box>
        </form>
      </FormControl>
    </>
  );
  return <div>{card}</div>;
};
export default EditCard;
